import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl } from '@angular/forms';
import { CheckAuth } from 'src/Services/utility.service';
import { ToastrService } from 'ngx-toastr';
import { MatrixService } from 'src/Services/matrix.service';
import { ActionActivity, ToolEnum } from 'src/Models/Common';
import { ApplicationActivityStore } from 'src/common/commonFunction';
import { ApplicationActivityService } from 'src/Services/application-activity.service';
import { ActionCompanySpecificCategoryModel, AddNewActionModel, userModel } from 'src/Models/TracItModel';
import { ActionItemService } from 'src/Services/tracit.service';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-tracit-add-new-action-popup',
  templateUrl: './add-new-action-popup.component.html',
  styleUrls: ['./add-new-action-popup.component.css']
})

export class TracItAddNewActionPopupComponent implements OnInit {
  @Input() IsActionFlag: any;
  @Input() title: string;
  addNewActionModel = new AddNewActionModel();
  userModel: userModel[];

  loginUser: number = 0;
  message: string;
  isCheckVisibleToAllCompanyUsers = false;
  tokenKey: string = '';
  companyId: number = 0;

  dropdownUserSettings = {};
  selectedItemsUser = [];
  dropdownListUser = [];

  dropdownCarrierCategoriesSettings = {};
  selectedItemsCarrierCategories = [];
  dropdownListCarrierCategories = [];

  dropdownStateSettings = {};
  selectedItemsState = [];
  dropdownListState = [];
  productId: number;

  listOfAssignToUser = [];

  bsConfig = {
  showWeekNumbers: false,
  dateInputFormat: 'MM/DD/YYYY',
  minDate: new Date()   // disables past dates
};

  addUpdateActionItem = new FormGroup({
    assignToUser: new FormControl(''),
    actionItemId: new FormControl(''),
    deadLineDate: new FormControl(''),
    subject: new FormControl(''),
    description: new FormControl(''),
    visibleTrackIt: new FormControl(0),
    state: new FormControl(''),
    carrierCategories: new FormControl(''),
    visibleUserIds: new FormControl(''),
    category: new FormControl(''),
    categoryText: new FormControl(''),
    country: new FormControl(''),
    recurrance: new FormControl(''),
    reminder: new FormControl(''),
    reminderUsers: new FormControl(''),
    notes: new FormControl(''),
    alertText: new FormControl(''),
  });

  EditActionId: number = 0;
  isOneClickOnButton: boolean = false;

  addNewCategoryText = '';
  isCountryUserSelected = false;
  isSpecificUserVisible = false;
  isAddNewCategory = false;
  isReminderUser = false;
  dropdownCountrySettings = {};
  selectedItemsCountry = [];
  dropdownListCountry = [];
  dropdownSingleSettings = {};
  selectedItemsVisible = [];
  dropdownListVisible = [];
  dropdownUsersSettings = {};
  selectedItemsReminderUsers = [];
  selectedItemsVisibleUsers = [];
  selectedItemsRecurrance = [];
  dropdownListRecurrance = [];
  selectedItemsReminder = [];
  dropdownListReminder = [];
  selectedItemsCompanySpecificCategory = [];
  dropdownListCompanySpecificCategory = [];

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  constructor(private readonly matrix: MatrixService,
    private readonly toastr: ToastrService,
    private readonly actionItemServices: ActionItemService,
    private readonly activeModal: NgbActiveModal,
    private readonly checkAuth: CheckAuth,
    private readonly appActivity: ApplicationActivityService,
    private sessionStorageService: SessionStorageService) {
    this.title = 'Add New Trac-It';
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
  }

  ngOnInit() {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.companyId = +sessionStorage.getItem("CompanyId");
    this.loginUser = +sessionStorage.getItem('UserId');
    this.productId = 4;
    this.GetUsersFindByCompanyId(this.companyId);
    this.GetCarrierCategories();
    this.GetStates(this.loginUser, this.productId);
    this.GetAllCountry();
    this.GetAllVisible();
    this.GetAllRecurrance();
    this.GetAllReminders();
    this.GetAllCompanyServiceCategory();
    this.selectedItemsRecurrance = this.dropdownListRecurrance.filter(x => x.id == 'None');
    this.selectedItemsReminder = this.dropdownListReminder.filter(x => x.id == 'None');
    this.selectedItemsVisible = this.dropdownListVisible.filter(x => x.id == 0);
    this.dropdownSingleSettings = {
      singleSelection: true,
      text: "Select",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 3,
      noDataLabel: 'No record available',
      showCheckbox: false,
    };
  }

  saveAddUpdateActionItem(addUpdateActionItem: any, isButtonDisable: boolean) {

    if (!this.selectedItemsVisible || this.selectedItemsVisible.length == 0) {
      this.showMessage('Please select visible type', 'Error', 'error');
      return;
    }
    this.addNewActionModel.visibleTrackIt = this.selectedItemsVisible[0].id;
    if (this.addNewActionModel.visibleTrackIt == 2 && this.selectedItemsVisibleUsers.length == 0) {
      this.showMessage('Please select visible users', 'Error', 'error');
      return;
    }

    if (addUpdateActionItem.value['deadLineDate'] == undefined || addUpdateActionItem.value['deadLineDate'] == '') {
      this.showMessage('Please select deadline date', 'Error', 'error');
      return;
    }

    if (addUpdateActionItem.value['subject'] == undefined || addUpdateActionItem.value['subject'] == '') {
      this.showMessage('Please enter subject', 'Error', 'error');
      return;
    }

    if (addUpdateActionItem.value['description'] == undefined || addUpdateActionItem.value['description'] == '') {
      this.showMessage('Please enter description', 'Error', 'error');
      return;
    }

    if (this.selectedItemsVisible[0].id == 0 && this.selectedItemsReminderUsers.length > 1) {
      this.showMessage('You can not select more then one user because trac-it visibility is “Visible to me only”.', 'Error', 'error');
      return;
    }

    if (this.selectedItemsCountry.length > 0)
      this.addNewActionModel.country = this.selectedItemsCountry[0].id;
    if (this.selectedItemsRecurrance.length > 0)
      this.addNewActionModel.recurrance = this.selectedItemsRecurrance[0].id;
    if (this.selectedItemsReminder.length > 0)
      this.addNewActionModel.reminder = this.selectedItemsReminder[0].id;
    if (this.selectedItemsCompanySpecificCategory.length > 0)
      this.addNewActionModel.category = this.selectedItemsCompanySpecificCategory[0].id;
    if (this.addNewActionModel.reminder != 'None' && this.selectedItemsReminderUsers.length == 0) {
      this.showMessage('Please select reminder users', 'Error', 'error');
      return;
    }
    if (this.addNewActionModel.reminder != 'None' && this.selectedItemsReminderUsers.length > 0 && !this.selectedItemsReminderUsers.find(x => x.id == this.loginUser)) {
      this.showMessage('You can not remove current user from reminder user', 'Error', 'error');
      return;
    }
    this.addNewActionModel.reminderUsers = this.selectedItemsReminderUsers;
    this.addNewActionModel.visibleUserIds = this.selectedItemsVisibleUsers;

    this.addNewActionModel.state = '';
    let state = addUpdateActionItem.value['state']

    let saprator = '';
    if (state != null) {
      for (let iCounter = 0; iCounter < state.length; iCounter++) {
        this.addNewActionModel.state += saprator + state[iCounter].id;
        saprator = ',';
      }
    }

    this.addNewActionModel.carrierCategories = '';
    let carrierCategories = addUpdateActionItem.value['carrierCategories']
    saprator = '';
    if (state != null) {
      for (let iCounter = 0; iCounter < carrierCategories.length; iCounter++) {
        this.addNewActionModel.carrierCategories += saprator + carrierCategories[iCounter].id;
        saprator = ',';
      }
    }

    if (addUpdateActionItem.value['actionItemId'] != 'undefined' && addUpdateActionItem.value['actionItemId'] != undefined)
      this.addNewActionModel.actionItemId = addUpdateActionItem.value['actionItemId'];
    else
      this.addNewActionModel.actionItemId = 0;

    if (this.addNewActionModel.assignToUser == null)
      this.addNewActionModel.assignToUser = '0';

    if (addUpdateActionItem.value['visibleToAllCompanyUsers'] != 'undefined' && addUpdateActionItem.value['visibleToAllCompanyUsers'] != undefined)
      this.addNewActionModel.visibleToAllCompanyUsers = addUpdateActionItem.value['visibleToAllCompanyUsers'];
    else
      this.addNewActionModel.visibleToAllCompanyUsers = false;

    if (addUpdateActionItem.value['description'] != undefined)
      this.addNewActionModel.description = addUpdateActionItem.value['description'];
    else
      this.addNewActionModel.description = null;

    this.addNewActionModel.subject = addUpdateActionItem.value['subject'];
    this.addNewActionModel.createdBy = +sessionStorage.getItem('UserId');
    this.addNewActionModel.companyId = this.companyId;
    this.addNewActionModel.actionItemId = 0;
    this.addNewActionModel.notes = addUpdateActionItem.value['notes'];

    event.preventDefault();

    if (isButtonDisable) {
      return;
    }

    this.isOneClickOnButton = true;

    this.actionItemServices.AddUpdateNewActionItem(this.tokenKey, this.addNewActionModel).subscribe(
      data => {
        this.isOneClickOnButton = false;
        if (data['status'] == 'Success') {
          this.showMessage('Entry saved successfully', 'Success', 'success');
          this.activeModal.close('Yes');
          //Add New Trac-It
          ApplicationActivityStore('Add', 'Add New Trac-It', this.appActivity, ToolEnum.actionitem, ActionActivity['Trac It'], '/trac-it/add');
        }
        else {
          this.showMessage(data['status'], 'Error', 'error');
        }
      },
      error => {
        this.showMessage(error, 'Error', 'error');
        this.isOneClickOnButton = false;
      }
    );
  }

  viewAllCompanyUser($event) {
    this.isCheckVisibleToAllCompanyUsers = $event.target.checked;
    this.selectedItemsUser = [];
    this.AssignUserDropDownSettings();
  }

  GetUsersFindByCompanyId(companyId: any) {
    this.actionItemServices.GetUsersFindByCompanyIdRemoveLoginUser(this.tokenKey, companyId, this.productId, this.loginUser).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.userModel = data['companyUsers'];
          if (this.userModel != null) {
            if (this.userModel.length > 0) {
              for (let iCounter = 0; iCounter < this.userModel.length; iCounter++) {
                this.dropdownListUser.push({ "id": parseInt(this.userModel[iCounter].userId), "itemName": this.userModel[iCounter].userName });
              }

              if (this.addNewActionModel != null) {
                if (+this.addNewActionModel.assignToUser > 0) {
                  this.selectedItemsUser = this.dropdownListUser.filter(x => x.id == +this.addNewActionModel.assignToUser);
                  this.addNewActionModel.previousAssingId = this.addNewActionModel.assignToUser;
                }
              }
            }
          }
        }
        this.AssignUserDropDownSettings();
        this.dropdownUsersSettings = {
          singleSelection: false,
          text: "Select User",
          enableSearchFilter: true,
          classes: "borderLessTextBoxGreen",
          badgeShowLimit: 3,
          noDataLabel: 'No user available',
          showCheckbox: true,
        };
      });
  }

  AssignUserDropDownSettings() {
    this.dropdownUserSettings = {
      singleSelection: true,
      text: "Select User",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 3,
      noDataLabel: 'No user available',
      showCheckbox: false,
      disabled: !this.isCheckVisibleToAllCompanyUsers
    };
  }
  onSelectedUser($event) {
    this.addNewActionModel.assignToUser = $event['id'];
  }

  onDeSelectedUser($event) {
    this.addNewActionModel.assignToUser = null;
  }

  onDeSelectAllUser($event) {
    this.addNewActionModel.assignToUser = null;
  }

  GetCarrierCategories() {
    this.actionItemServices.GetCarrierCategories(this.tokenKey).subscribe(
      data => {
        if (data['status'] == 'Success') {
          let carrierCategories = data['companyModel'];
          if (carrierCategories != null) {
            if (carrierCategories.length > 0) {
              for (let iCounter = 0; iCounter < carrierCategories.length; iCounter++) {
                this.dropdownListCarrierCategories.push({ "id": parseInt(carrierCategories[iCounter].carrierCatId), "itemName": carrierCategories[iCounter].carrierCatName });
              }
            }
          }
        }

        this.dropdownCarrierCategoriesSettings = {
          singleSelection: false,
          text: "Select Carrier Type Summary",
          enableSearchFilter: true,
          classes: "borderLessTextBoxGreen",
          badgeShowLimit: 3,
          noDataLabel: 'No carrier type summary available',
          showCheckbox: true
        };
      });
  }

  onSelectedCarrierCategories($event) {
  }

  onDeSelectedCarrierCategories($event) {

  }

  GetStates(userId: any, productId: any) {
    this.matrix.getState(this.tokenKey, userId, productId).subscribe(
      data => {
        if (data["state"] != null) {
          this.selectedItemsState = [];
          for (let iCounter = 0; iCounter < data["state"].length; iCounter++) {
            this.dropdownListState.push(
              { "id": data["state"][iCounter].stateId, "itemName": data["state"][iCounter].name }
            );
          }
        }

        this.setStateSettings();
      }, error => {

      })
  }

  isDeadlineDate(dateArray: any) {
    if (dateArray != null) {
      let dd1 = dateArray.getDate().toString();
      if (parseInt(dd1.toString()) < 10)
        dd1 = '0' + dd1.toString();

      let mm1 = (dateArray.getMonth() + 1).toString();
      if (parseInt(mm1.toString()) < 10)
        mm1 = '0' + mm1.toString();

      this.addNewActionModel.deadLineDate = mm1 + '-' + dd1 + '-' + dateArray.getFullYear();
    }
    else
      this.addNewActionModel.deadLineDate = null;
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  onChangeVisible(event) {
    this.isSpecificUserVisible = false;
    this.isCheckVisibleToAllCompanyUsers = false;
    this.selectedItemsUser = [];
    this.selectedItemsVisibleUsers = [];

    if (this.selectedItemsReminderUsers != null) {
      if (this.selectedItemsReminderUsers.length > 1 && event.id == 0) {
        document.getElementById("openModalButton").click();
      }

      if (this.isReminderUser && this.selectedItemsReminderUsers.length == 0) {
        this.selectedItemsReminderUsers = this.dropdownListUser.filter(x => x.id == this.loginUser);
      }
      else if (this.selectedItemsReminderUsers.length == 1) {
        if (this.selectedItemsReminderUsers[0].id != this.loginUser) {
          this.selectedItemsReminderUsers = [];
          this.selectedItemsReminderUsers = this.dropdownListUser.filter(x => x.id == this.loginUser);
        }
      }
    }

    if (event) {
      if (Array.isArray(event) && event.length == 0) {
        this.selectedItemsVisible = [];
      }
      else {
        if (event.id == 1) {
          this.isCheckVisibleToAllCompanyUsers = true;
        }
        else if (event.id == 2) {
          this.isCheckVisibleToAllCompanyUsers = true;
          this.isSpecificUserVisible = true;
        }
      }
    }
    this.AssignUserDropDownSettings();
  }

  onChangeCountry(event) {
    this.isCountryUserSelected = false;
    if (event && event.itemName != 'United States (USA)') {
      this.isCountryUserSelected = true;
    }
    this.setStateSettings();
  }

  onChangeReminder(event) {
    this.isReminderUser = false;
    this.selectedItemsReminderUsers = [];
    if (event) {
      if (Array.isArray(event) && event.length == 0) {
        this.isReminderUser = false;
      }
      else if (event.id != 'None') {
        this.isReminderUser = true;
        this.selectedItemsReminderUsers = this.dropdownListUser.filter(x => x.id == this.loginUser);
      }
    }
  }

  onChangeCategory(event) {
    this.isAddNewCategory = false;
    if (event) {
      if (event.id < 0) {
        this.isAddNewCategory = true;
      }
    }
  }

  setStateSettings() {
    this.dropdownStateSettings = {
      singleSelection: false,
      text: "Select State(s)",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 1,
      noDataLabel: 'No state available',
      showCheckbox: true,
      enableFilterSelectAll: false,
      enableCheckAll: true,
      disabled: this.isCountryUserSelected
    };
  }

  onSelectedState($event) {
  }

  onDeSelectedState($event) {
  }

  saveCompanySpecificCategory() {
    if (!this.addNewCategoryText) {
      this.showMessage('Please enter category name', 'Error', 'error');
      return;
    }
    const category = new ActionCompanySpecificCategoryModel();
    category.companyId = this.companyId;
    category.name = this.addNewCategoryText;
    category.createdBy = this.loginUser;

    this.actionItemServices.ActionCompanySpecificCategoryAddUpdate(this.tokenKey, category).subscribe(
      data => {
        this.isOneClickOnButton = false;
        if (data['status'] == 'Success') {
          this.showMessage('Entry saved successfully', 'Success', 'success');
          this.selectedItemsCompanySpecificCategory = [];
          const item = { id: data.result, itemName: this.addNewCategoryText };
          this.selectedItemsCompanySpecificCategory.push(item);
          this.GetAllCompanyServiceCategory();
          this.addNewCategoryText = '';
          this.isAddNewCategory = false;
        } else if (data.result == -1) {
          this.showMessage('Category name is already exists.', 'Error', 'error');
        } else {
          this.showMessage(data['status'], 'Error', 'error');
        }
      },
      error => {
        this.showMessage(error, 'Error', 'error');
        this.isOneClickOnButton = false;
      }
    );
  }

  GetAllCountry() {
    this.actionItemServices.getCountry(this.tokenKey).subscribe(data => {
      if (data['status'] == 'Success') {
        for (let iCounter = 0; iCounter < data.countryList.length; iCounter++) {
          this.dropdownListCountry.push({ "id": parseInt(data.countryList[iCounter].countryId), "itemName": (data.countryList[iCounter].name + ' (' + data.countryList[iCounter].shortName + ')') });

        }
        this.selectedItemsCountry = this.dropdownListCountry.filter(x => x.itemName == 'United States (USA)');
      }
      this.dropdownCountrySettings = {
        singleSelection: true,
        text: "Select Country",
        enableSearchFilter: true,
        classes: "borderLessTextBoxGreen",
        badgeShowLimit: 3,
        noDataLabel: 'No country available',
        showCheckbox: false
      };
    })
  }

  GetAllVisible() {
    this.dropdownListVisible.push({ "id": 0, "itemName": "Visible to me only" });
    this.dropdownListVisible.push({ "id": 1, "itemName": "Visible to all company users" });
    this.dropdownListVisible.push({ "id": 2, "itemName": "Visible to specific users " });
  }
  GetAllRecurrance() {
    this.dropdownListRecurrance.push({ "id": 'None', "itemName": "None" });
    this.dropdownListRecurrance.push({ "id": 'Annual', "itemName": "Annual" });
    this.dropdownListRecurrance.push({ "id": 'Quarterly', "itemName": "Quarterly" });
    this.dropdownListRecurrance.push({ "id": 'Every 2 months', "itemName": "Every 2 months" });
    this.dropdownListRecurrance.push({ "id": 'Every 1 month', "itemName": "Every 1 month" });
    this.dropdownListRecurrance.push({ "id": 'Every 2 weeks', "itemName": "Every 2 weeks" });
    // this.dropdownListRecurrance.push({ "id": 'Every 1 day', "itemName": "Every 1 day" });
  }
  GetAllReminders() {
    this.dropdownListReminder.push({ "id": 'None', "itemName": "None" });
    this.dropdownListReminder.push({ "id": 'Before 2 months', "itemName": "Before 2 months" });
    this.dropdownListReminder.push({ "id": 'Before 1 month', "itemName": "Before 1 month" });
    this.dropdownListReminder.push({ "id": 'Before 2 weeks', "itemName": "Before 2 weeks" });
    this.dropdownListReminder.push({ "id": 'Before 1 day', "itemName": "Before 1 day" });
  }
  GetAllCompanyServiceCategory() {
    this.dropdownListCompanySpecificCategory = [];
    this.actionItemServices.GetAllActionCompanySpecificCategory(this.tokenKey, this.companyId).subscribe(data => {
      if (data['status'] == 'Success') {
        if (data.result != null) {
          if (data.result.length > 0) {
            for (let iCounter = 0; iCounter < data.result.length; iCounter++) {
              this.dropdownListCompanySpecificCategory.push({ "id": parseInt(data.result[iCounter].actionCompanySpecificCategoryId), "itemName": data.result[iCounter].name });
            }
          }
          this.dropdownListCompanySpecificCategory.push({ id: -1, itemName: "New >" });
        }
      }
    })
  }

  onSelectedReminderUser($event) {
    if (this.selectedItemsReminderUsers != null) {
      if (this.selectedItemsReminderUsers.length > 1) {
        if (this.selectedItemsVisible[0].id == 0) {
          this.selectedItemsReminderUsers = this.removeElemetsFromArray(this.selectedItemsReminderUsers, $event.id)
          document.getElementById("openModalButton").click();
        }
        else {
          this.selectedItemsReminderUsers = this.removeElemetsFromArray(this.selectedItemsReminderUsers, $event.id)
          this.selectedItemsReminderUsers.push($event);
        }
      }
      else {
        if (this.selectedItemsVisible[0].id == 0 && $event.id != this.loginUser) {
          this.selectedItemsReminderUsers = [];
          this.showMessage('You can not select other user because trac-it visibility is only me', 'Error', 'error');
        }
      }
    }
  }

  removeElemetsFromArray(array, element) {
    this.selectedItemsReminderUsers = this.dropdownListUser.filter(x => x.id == this.loginUser);
    return array.filter(e => e.id !== element);
  }

  clearSelectedVisibleItem() {
    this.selectedItemsVisible = [];
  }

  onSelectedAllReminderUser($event) {
    if (this.selectedItemsReminderUsers != null) {
      if (this.selectedItemsReminderUsers.length > 0 && this.selectedItemsVisible.length > 0) {
        if (this.selectedItemsVisible[0].id == 0) {
          this.selectedItemsReminderUsers = [];
          this.selectedItemsReminderUsers = this.dropdownListUser.filter(x => x.id == this.loginUser);
          document.getElementById("openModalButton").click();
        }
      }
    }
  }
  onDeselectedAllReminderUser($event) {
    this.selectedItemsReminderUsers = [];
    if (this.selectedItemsVisible.length > 0) {
      if (this.selectedItemsVisible[0].id == 0 && this.selectedItemsReminderUsers.length == 0) {
        this.selectedItemsReminderUsers = this.dropdownListUser.filter(x => x.id == this.loginUser);
      }
    }
  }

  onDeselectedReminderUser($event) {
    if (this.selectedItemsVisible.length > 0) {
      if (this.selectedItemsVisible[0].id == 0 && this.selectedItemsReminderUsers.length == 0 && $event.id == this.loginUser) {
        this.showMessage('You can not remove current user from reminder user', 'Error', 'error');
        this.selectedItemsReminderUsers = this.dropdownListUser.filter(x => x.id == this.loginUser);
      }
    }
  }
}
